var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*eslint no-useless-escape: 0*/
import React, { useState, useEffect } from 'react';
import { Box, Button, IconButton, Typography, MenuItem, Grid, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import GridComp from '../../../../../components/grid';
import { MODOS, MENSAGENS, getDataFormatada, validarData, verificarDatas } from '../../../../../utils';
import { ROUTES, FUNCIONALIDADES } from '../../../../../routes';
import { BoxBotoes } from '../../../../../components/form_box';
import Loading from '../../../../../components/loading';
import { useParams } from 'react-router-dom';
import { getReeducandoFormacoes, cadastrarFormacao, alterarFormacao, excluirFormacao, STATUS_API, getComboFormacoes } from './services';
import { BotaoSalvar, BotaoFechar, BotaoAuxiliar } from '../../../../../components/botoes';
import { InputDados } from '../../../../../components/input_dados';
import { VisibilityOutlined as VisibilityOutlinedIcon, ModeEditOutlined as ModeEditOutlinedIcon, DeleteOutline as DeleteOutlineIcon, } from '@mui/icons-material';
import { useAuth } from '../../../../../contexts/auth/AuthContext';
export var ReeducandosFormacoesQualificacoes = function (props) {
    var _a = useAuth(), getAcoesFuncionalidade = _a.getAcoesFuncionalidade, DEV = _a.DEV;
    var AcoesFuncionalidade = getAcoesFuncionalidade(FUNCIONALIDADES.REEDUCANDOS_FORMACOES);
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useParams(), id = _c.id, modo = _c.modo;
    var _d = useState([]), Formacoes = _d[0], setFormacoes = _d[1];
    var _e = useState([]), FormacoesPendentes = _e[0], setFormacoesPendentes = _e[1];
    var _f = useState([]), NiveisEscolaridadeDisponiveis = _f[0], setNiveisEscolaridadeDisponiveis = _f[1];
    var _g = useState([]), TiposFormacoesDisponiveis = _g[0], setTiposFormacoesDisponiveis = _g[1];
    var _h = useState(''), Curso = _h[0], setCurso = _h[1];
    var _j = useState(-1), TipoFormacaoSelecionada = _j[0], setTipoFormacaoSelecionada = _j[1];
    var _k = useState(-1), NivelEscolaridadeSelecionada = _k[0], setNivelEscolaridadeSelecionada = _k[1];
    var _l = useState(''), DataInicio = _l[0], setDataInicio = _l[1];
    var _m = useState(), DataFim = _m[0], setDataFim = _m[1];
    var _o = useState(''), NomeArquivoOriginal = _o[0], setNomeArquivoOriginal = _o[1];
    var _p = useState(null), ArquivoSelecionado = _p[0], setArquivoSelecionado = _p[1];
    var _q = useState(false), PopupAberto = _q[0], setPopupAberto = _q[1];
    var _r = useState(), EditarID = _r[0], setEditarID = _r[1];
    var _s = useState(''), EditarCurso = _s[0], setEditarCurso = _s[1];
    var _t = useState(-1), EditarTipoFormacaoSelecionada = _t[0], setEditarTipoFormacaoSelecionada = _t[1];
    var _u = useState(-1), EditarNivelEscolaridadeSelecionada = _u[0], setEditarNivelEscolaridadeSelecionada = _u[1];
    var _v = useState(''), EditarDataInicio = _v[0], setEditarDataInicio = _v[1];
    var _w = useState(), EditarDataFim = _w[0], setEditarDataFim = _w[1];
    var _x = useState(''), EditarNomeArquivoOriginal = _x[0], setEditarNomeArquivoOriginal = _x[1];
    var _y = useState(-1), EditarTipoDocumentoSelecionado = _y[0], setEditarTipoDocumentoSelecionado = _y[1];
    var setAbaAtiva = props.setAbaAtiva;
    var PODE_CADASTRAR = !!AcoesFuncionalidade['CADASTRAR'];
    var PODE_EDITAR = !!AcoesFuncionalidade['ALTERAR'];
    var PODE_EXCLUIR = !!AcoesFuncionalidade['EXCLUIR'];
    var DESABILITAR_CAMPOS = modo == MODOS.VISUALIZAR || modo == MODOS.EXCLUIR || !(PODE_EDITAR || PODE_CADASTRAR);
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, RespCombos, ReeducandoDadosAux, niveis_escolaridade, tipos_formacoes, formacoes;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!id) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all([getComboFormacoes(), getReeducandoFormacoes(id)])];
                case 1:
                    _a = _b.sent(), RespCombos = _a[0], ReeducandoDadosAux = _a[1];
                    if (RespCombos.Status == STATUS_API.ERRO) {
                        alert(RespCombos.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        niveis_escolaridade = RespCombos.niveis_escolaridade, tipos_formacoes = RespCombos.tipos_formacoes;
                        setNiveisEscolaridadeDisponiveis(niveis_escolaridade);
                        setTiposFormacoesDisponiveis(tipos_formacoes);
                    }
                    if (ReeducandoDadosAux.Status == STATUS_API.ERRO) {
                        alert(ReeducandoDadosAux.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        formacoes = ReeducandoDadosAux.formacoes;
                        setFormacoes(formacoes);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    alert('ID do Colaborador não informado');
                    _b.label = 3;
                case 3:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validarDados = function () {
        if (!Curso || Curso.trim() == '') {
            alert("Curso ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!TipoFormacaoSelecionada || TipoFormacaoSelecionada == -1) {
            alert("Tipo de Forma\u00E7\u00E3o ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!NivelEscolaridadeSelecionada || NivelEscolaridadeSelecionada == -1) {
            alert("N\u00EDvel de Escolaridade ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!DataInicio || DataInicio.trim() == '') {
            alert("Data de In\u00EDcio ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!validarData(DataInicio)) {
            alert("Data de In\u00EDcio ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        var DataFimNormalizada = DataFim || '';
        if ((DataFimNormalizada.trim()) != '') {
            if (!validarData(DataFimNormalizada)) {
                alert("Data Fim  ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
                return false;
            }
            if (!verificarDatas(DataInicio, DataFimNormalizada)) {
                alert('Data de Fim deve ser maior que a Data de Início');
                return false;
            }
        }
        return true;
    };
    var validarDadosEditar = function () {
        if (!EditarCurso || EditarCurso.trim() == '') {
            alert("Curso ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!EditarTipoFormacaoSelecionada || EditarTipoFormacaoSelecionada == -1) {
            alert("Tipo de Forma\u00E7\u00E3o ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!EditarNivelEscolaridadeSelecionada || EditarNivelEscolaridadeSelecionada == -1) {
            alert("N\u00EDvel de Escolaridade ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var handleFileChange = function (event) {
        var _a, _b;
        if (!((_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0]))
            return;
        var file = event.target.files[0];
        var fileName = file.name;
        var fileExtension = (_b = fileName.split('.').pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        if (fileExtension !== 'pdf') {
            alert('Selecione um arquivo do tipo PDF');
            event.target.value = '';
            return;
        }
        setArquivoSelecionado(file);
        setNomeArquivoOriginal(fileName);
    };
    var adicionarFormacaoLocal = function () {
        if (!validarDados())
            return;
        var tipoFormacao = TiposFormacoesDisponiveis.find(function (t) { return t.id === TipoFormacaoSelecionada; });
        var nivelEscolaridade = NiveisEscolaridadeDisponiveis.find(function (n) { return n.id === NivelEscolaridadeSelecionada; });
        var novaPendente = {
            id: "pending_".concat(Date.now()),
            curso: Curso,
            tipo_formacao_id: TipoFormacaoSelecionada,
            nivel_escolaridade_id: NivelEscolaridadeSelecionada,
            tipo_formacao: tipoFormacao,
            nivel_escolaridade: nivelEscolaridade,
            ano_inicio: DataInicio || null,
            ano_conclusao: DataFim || null,
            nome_arquivo_original: NomeArquivoOriginal,
            _arquivo: ArquivoSelecionado,
            _pending: true,
        };
        setFormacoesPendentes(function (prev) { return __spreadArray(__spreadArray([], prev, true), [novaPendente], false); });
        limparSelecao();
    };
    var removerPendente = function (pendingId) {
        setFormacoesPendentes(function (prev) { return prev.filter(function (f) { return f.id !== pendingId; }); });
    };
    var salvarFormacoes = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _i, FormacoesPendentes_1, pendente, FormDataAux, Resposta;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (FormacoesPendentes.length === 0)
                        return [2 /*return*/];
                    setLoading(true);
                    _i = 0, FormacoesPendentes_1 = FormacoesPendentes;
                    _a.label = 1;
                case 1:
                    if (!(_i < FormacoesPendentes_1.length)) return [3 /*break*/, 4];
                    pendente = FormacoesPendentes_1[_i];
                    FormDataAux = new FormData();
                    FormDataAux.append('curso', pendente.curso);
                    FormDataAux.append('tipo_formacao_id', pendente.tipo_formacao_id.toString());
                    FormDataAux.append('nivel_escolaridade_id', pendente.nivel_escolaridade_id.toString());
                    if (pendente.ano_inicio)
                        FormDataAux.append('ano_inicio', pendente.ano_inicio);
                    if (pendente.ano_conclusao)
                        FormDataAux.append('ano_conclusao', pendente.ano_conclusao);
                    if (pendente._arquivo) {
                        FormDataAux.append('nome_arquivo_original', pendente._arquivo.name);
                        FormDataAux.append('arquivo', pendente._arquivo);
                    }
                    return [4 /*yield*/, cadastrarFormacao(FormDataAux, id !== null && id !== void 0 ? id : '')];
                case 2:
                    Resposta = _a.sent();
                    if (Resposta.Status === STATUS_API.ERRO) {
                        alert(Resposta.Mensagem);
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    setFormacoesPendentes([]);
                    return [4 /*yield*/, carregarDados()];
                case 5:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var alterarDocumento = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, FormacoesAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validarDadosEditar() || !EditarTipoDocumentoSelecionado)
                        return [2 /*return*/];
                    setLoading(true);
                    Dados = {
                        curso: EditarCurso,
                        tipo_formacao_id: EditarTipoFormacaoSelecionada,
                        nivel_escolaridade_id: EditarNivelEscolaridadeSelecionada,
                        ano_inicio: EditarDataInicio,
                        ano_conclusao: EditarDataFim,
                    };
                    return [4 /*yield*/, alterarFormacao(Dados, EditarID ? EditarID.toString() : '')];
                case 1:
                    Resp = _a.sent();
                    DEV && console.log('Resp', JSON.stringify(Resp));
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        FormacoesAtualizados = Formacoes.map(function (arquivo) {
                            if (arquivo.id == EditarID) {
                                return __assign(__assign({}, arquivo), Dados);
                            }
                            return arquivo;
                        });
                        setFormacoes(FormacoesAtualizados);
                        setPopupAberto(false);
                        limparPopup();
                    }
                    else {
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp, updatedFormacoes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO)) return [3 /*break*/, 2];
                    setLoading(true);
                    return [4 /*yield*/, excluirFormacao(id)];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        updatedFormacoes = Formacoes.filter(function (Item) { return Item.id != +id; });
                        setFormacoes(updatedFormacoes);
                    }
                    else {
                        setLoading(false);
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var limparSelecao = function () {
        setCurso('');
        setTipoFormacaoSelecionada(-1);
        setNivelEscolaridadeSelecionada(-1);
        setDataInicio('');
        setDataFim('');
        setArquivoSelecionado(null);
        setNomeArquivoOriginal('');
    };
    var limparPopup = function () {
        setEditarID(undefined);
        setEditarCurso('');
        setEditarTipoFormacaoSelecionada(-1);
        setEditarNivelEscolaridadeSelecionada(-1);
        setEditarDataInicio('');
        setEditarDataFim('');
        setEditarTipoDocumentoSelecionado(-1);
        setEditarNomeArquivoOriginal('');
    };
    // Normaliza os diferentes formatos em que o arquivo pode chegar da API:
    // - Buffer serializado: { type: 'Buffer', data: [...] }
    // - Uint8Array serializado como objeto { '0': .., '1': .. } (Prisma v6 Bytes)
    // - array puro de bytes
    // - string base64
    var getBytesArquivo = function (ArquivoParm) {
        if (!ArquivoParm)
            return new Uint8Array();
        if (ArquivoParm instanceof Uint8Array)
            return ArquivoParm;
        if (Array.isArray(ArquivoParm))
            return new Uint8Array(ArquivoParm);
        if (Array.isArray(ArquivoParm.data))
            return new Uint8Array(ArquivoParm.data);
        if (typeof ArquivoParm === 'string') {
            var bin = atob(ArquivoParm);
            var bytes = new Uint8Array(bin.length);
            for (var i = 0; i < bin.length; i++)
                bytes[i] = bin.charCodeAt(i);
            return bytes;
        }
        // Objeto com chaves numéricas (Uint8Array serializado em JSON)
        return Uint8Array.from(Object.values(ArquivoParm));
    };
    var handleViewFile = function (ArquivoParm) {
        var ArquivoByteArray = getBytesArquivo(ArquivoParm);
        if (!ArquivoByteArray.length) {
            alert('Arquivo indisponível para visualização.');
            return;
        }
        var ArquivoBlob = new Blob([ArquivoByteArray], { type: 'application/pdf' });
        var URLAux = URL.createObjectURL(ArquivoBlob);
        window.open(URLAux, '_blank');
    };
    var COLUNAS_ARQUIVOS = [
        {
            field: 'curso',
            headerName: 'Curso',
            width: 300,
        },
        {
            field: 'tipo_formacao_id',
            headerName: 'Tipo de Formação',
            width: 200,
            valueGetter: function (_value, row) { var _a; return (_a = row.tipo_formacao) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'nivel_escolaridade_id',
            headerName: 'Nível de Escolaridade',
            width: 200,
            valueGetter: function (_value, row) { var _a; return (_a = row.nivel_escolaridade) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'ano_inicio',
            headerName: 'Ano Início',
            width: 150,
            valueGetter: function (_value, row) { return (row.ano_inicio ? getDataFormatada(row.ano_inicio) : ''); },
        },
        {
            field: 'ano_conclusao',
            headerName: 'Ano Conclusão',
            width: 150,
            valueGetter: function (_value, row) { return (row.ano_conclusao ? getDataFormatada(row.ano_conclusao) : ''); },
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 120,
            renderCell: function (params) { return (_jsx(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }, { children: params.row._pending ? (_jsx(Box, __assign({ bgcolor: 'error.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { return removerPendente(params.row.id); } }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) }))) : (_jsxs(_Fragment, { children: [params.row.nome_arquivo_original && (_jsx(Box, __assign({ bgcolor: 'secondary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 1, marginTop: -1 }, onClick: function () { return handleViewFile(params.row.arquivo); }, disabled: !AcoesFuncionalidade['VISUALIZAR'] }, { children: _jsx(VisibilityOutlinedIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) }))), PODE_EDITAR && (_jsx(Box, __assign({ bgcolor: !DESABILITAR_CAMPOS ? 'primary.main' : 'action.disabledBackground', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { return abrirPopup(params.row.id); }, disabled: DESABILITAR_CAMPOS }, { children: _jsx(ModeEditOutlinedIcon, { fontSize: 'medium', style: { color: !DESABILITAR_CAMPOS ? 'white' : 'rgba(0, 0, 0, 0.38)', marginBottom: 5, paddingBottom: 5 } }) })) }))), PODE_EXCLUIR && (_jsx(Box, __assign({ bgcolor: modo !== MODOS.VISUALIZAR && modo !== MODOS.EXCLUIR ? 'error.main' : 'action.disabledBackground', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { return handleDelete(params.row.id); }, disabled: modo === MODOS.VISUALIZAR || modo === MODOS.EXCLUIR }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'medium', style: {
                                        color: modo !== MODOS.VISUALIZAR && modo !== MODOS.EXCLUIR ? 'white' : 'rgba(0, 0, 0, 0.38)',
                                        marginBottom: 5,
                                        paddingBottom: 5,
                                    } }) })) })))] })) }))); },
        },
    ];
    var abrirPopup = function (DocumentoID) {
        if (!PODE_EDITAR)
            return;
        var Documento = Formacoes.find(function (Item) { return Item.id == +DocumentoID; });
        if (Documento) {
            setEditarID(Documento.id);
            setEditarCurso(Documento.curso);
            setEditarTipoFormacaoSelecionada(Documento.tipo_formacao_id);
            setEditarNivelEscolaridadeSelecionada(Documento.nivel_escolaridade_id);
            setEditarDataInicio(getDataFormatada(Documento.ano_inicio));
            setEditarDataFim(Documento.ano_conclusao ? getDataFormatada(Documento.ano_conclusao) : undefined);
            setEditarNomeArquivoOriginal(Documento.nome_arquivo_original);
        }
        setPopupAberto(true);
    };
    var handleClose = function () {
        if (confirm('Tem certeza que deseja sair?')) {
            setPopupAberto(false);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ mt: 5 }, { children: [_jsx(Typography, __assign({ variant: 'h6', gutterBottom: true }, { children: "Forma\u00E7\u00E3o / Qualifica\u00E7\u00E3o" })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'curso', label: 'Curso', value: Curso, onChange: function (event) { return setCurso(event.target.value); }, required: true, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'tipo_formacao', label: 'Tipo de Forma\u00E7\u00E3o', placeholder: 'Tipo de Forma\u00E7\u00E3o', value: TipoFormacaoSelecionada, onChange: function (event) {
                                        setTipoFormacaoSelecionada(event.target.value);
                                    }, required: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), TiposFormacoesDisponiveis === null || TiposFormacoesDisponiveis === void 0 ? void 0 : TiposFormacoesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'nivel_escolaridade', label: 'N\u00EDvel de Escolaridade', placeholder: 'N\u00EDvel de Escolaridade', value: NivelEscolaridadeSelecionada, onChange: function (event) {
                                        setNivelEscolaridadeSelecionada(event.target.value);
                                    }, required: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), NiveisEscolaridadeDisponiveis === null || NiveisEscolaridadeDisponiveis === void 0 ? void 0 : NiveisEscolaridadeDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: [_jsx("input", { accept: 'application/pdf', style: { display: 'none' }, id: 'arquivo-upload', type: 'file', onChange: handleFileChange, value: '', disabled: DESABILITAR_CAMPOS }), _jsx("label", __assign({ htmlFor: 'arquivo-upload' }, { children: _jsxs(BotaoAuxiliar, __assign({ component: 'label', backgroundColor: 'terceary.main', disabled: DESABILITAR_CAMPOS }, { children: ["Selecionar Arquivo", _jsx("input", { type: 'file', accept: 'application/pdf', hidden: true, onChange: handleFileChange, value: '', disabled: DESABILITAR_CAMPOS })] })) })), NomeArquivoOriginal && _jsx(InputDados, { id: 'nome_arquivo_original', variant: 'standard', value: NomeArquivoOriginal, disabled: true })] })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'ano-inicio', label: 'Data de In\u00EDcio', value: DataInicio, mask: '99/99/9999', onChange: function (event) { return setDataInicio(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'ano-termino', label: 'Data de T\u00E9rmino', value: DataFim, mask: '99/99/9999', onChange: function (event) { return setDataFim(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 12 }, { children: [_jsx(BotaoAuxiliar, __assign({ onClick: limparSelecao, backgroundColor: 'error.main', disabled: DESABILITAR_CAMPOS }, { children: "Limpar" })), _jsx(BotaoAuxiliar, __assign({ sx: { ml: 1 }, onClick: adicionarFormacaoLocal, backgroundColor: 'principal.main', disabled: DESABILITAR_CAMPOS || !PODE_CADASTRAR }, { children: "Adicionar" }))] }))] }))] })), _jsx(Box, __assign({ mt: 8 }, { children: _jsx(GridComp, { rows: __spreadArray(__spreadArray([], Formacoes, true), FormacoesPendentes, true), columns: COLUNAS_ARQUIVOS, loading: loading, paginationMode: 'client', onPaginationModelChange: function () { }, getRowClassName: function (params) { return (params.row._pending ? 'row-pendente' : ''); }, sx: {
                        '& .row-pendente': {
                            fontStyle: 'italic',
                            opacity: 0.75,
                        },
                    } }) })), _jsxs(BoxBotoes, __assign({ sx: { marginTop: 10 } }, { children: [_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'terceary.main', onClick: function () { return setAbaAtiva(3); } }, { children: "Voltar" })), PODE_CADASTRAR && !DESABILITAR_CAMPOS && _jsx(BotaoSalvar, { onClick: salvarFormacoes, disabled: FormacoesPendentes.length === 0 }), _jsx(BotaoFechar, { modo: modo, pagina: ROUTES.REEDUCANDOS })] })), _jsxs(Dialog, __assign({ open: PopupAberto, onClose: handleClose, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Editar Forma\u00E7\u00E3o / Qualifica\u00E7\u00E3o" }), _jsxs(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: [_jsx(Box, __assign({ mb: 2, mt: 2 }, { children: _jsx(InputDados, { id: 'id', label: 'ID', value: EditarID, disabled: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-curso', label: 'Curso', value: EditarCurso, onChange: function (event) { return setEditarCurso(event.target.value); }, required: true, disabled: !PODE_EDITAR }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-tipo-formacao', label: 'Tipo de Forma\u00E7\u00E3o', placeholder: 'Tipo de Forma\u00E7\u00E3o', value: EditarTipoFormacaoSelecionada, onChange: function (event) {
                                        setEditarTipoFormacaoSelecionada(event.target.value);
                                    }, required: true, disabled: !PODE_EDITAR }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), TiposFormacoesDisponiveis === null || TiposFormacoesDisponiveis === void 0 ? void 0 : TiposFormacoesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-nivel-escolaridade', label: 'N\u00EDvel de Escolaridade', placeholder: 'N\u00EDvel de Escolaridade', value: EditarNivelEscolaridadeSelecionada, onChange: function (event) {
                                        setEditarNivelEscolaridadeSelecionada(event.target.value);
                                    }, required: true, disabled: !PODE_EDITAR }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), NiveisEscolaridadeDisponiveis === null || NiveisEscolaridadeDisponiveis === void 0 ? void 0 : NiveisEscolaridadeDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-ano-inicio', label: 'Data de In\u00EDcio', value: EditarDataInicio, mask: '99/99/9999', onChange: function (event) { return setEditarDataInicio(event.target.value); }, disabled: !PODE_EDITAR }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-ano-termino', label: 'Data de T\u00E9rmino', value: EditarDataFim, mask: '99/99/9999', onChange: function (event) { return setEditarDataFim(event.target.value); }, disabled: !PODE_EDITAR }) })), EditarNomeArquivoOriginal && (_jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'nome-arquivo-original-editar', label: 'Arquivo', value: EditarNomeArquivoOriginal, disabled: true }) })))] })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Cancelar" })), _jsx(Button, __assign({ onClick: alterarDocumento, variant: 'contained', color: 'primary', disabled: !PODE_EDITAR }, { children: "Salvar" }))] }))] })), loading && _jsx(Loading, {})] }));
};
export default ReeducandosFormacoesQualificacoes;
